import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Components/CSS/Sidebar.css";

import {
  FaBoxOpen,
  FaShoppingCart,
  FaCreditCard,
  FaUsers,
  FaCog,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { FiLogOut } from "react-icons/fi";

import logo from "../Components/Icon.png";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [active, setActive] = useState("");

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <MdDashboard /> },
    { name: "Products", path: "/products", icon: <FaBoxOpen /> },
    { name: "Orders", path: "/orders", icon: <FaShoppingCart /> },
    { name: "Payments", path: "/payments", icon: <FaCreditCard /> },
    { name: "Customers", path: "/customers", icon: <FaUsers /> },
    { name: "Content / Settings", path: "/content-settings", icon: <FaCog /> },
  ];

  useEffect(() => {
    if (location.pathname === "/admin-profile") {
      setActive("");
      return;
    }

    if (location.pathname === "/") {
      setActive("Dashboard");
      return;
    }

    const current = menuItems.find((item) => item.path === location.pathname);

    if (current) {
      setActive(current.name);
    } else {
      setActive("");
    }
  }, [location.pathname]);

  return (
    <div className="sidebar">
      <div className="logo-section">
        <div className="logo-left">
          <img src={logo} alt="logo" className="logo-img" />
          <span className="logo-title">House of Elan</span>
        </div>

        {/* <IoIosArrowBack className="arrow-icon" /> */}
      </div>

      <div className="divider"></div>

      <ul className="menu">
        {menuItems.map((item) => (
          <li key={item.name} className={active === item.name ? "active" : ""}>
            <Link
              to={item.path}
              className="menu-link"
              onClick={() => setActive(item.name)}
            >
              <span className="icon">{item.icon}</span>
              <span className="label">{item.name}</span>
            </Link>
          </li>
        ))}
      </ul>

      <div className="divider"></div>

      {/* LOGOUT POPUP ROUTE */}
      <div
        className="logout"
        onClick={() =>
          navigate("/logoutpopup", {
            state: { background: location },
          })
        }
      >
        <FiLogOut className="logout-icon" />
        <span>Logout</span>
      </div>
    </div>
  );
};

export default Sidebar;
